export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-foreground-900 text-white overflow-hidden">
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <span className="absolute -bottom-10 -right-10 font-heading text-[15rem] md:text-[22rem] font-bold text-white/[0.03] leading-none whitespace-nowrap">
          RSE
        </span>
      </div>

      <div className="relative max-w-6xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="/" className="font-heading text-3xl font-light tracking-[0.15em] text-white inline-block mb-4">
              RSE
            </a>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              テクノロジーの光で、未来を紡ぐ。
              東京・新宿から、最高のソリューションをお届けします。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-medium tracking-[0.1em] text-white/60 mb-5">
              MENU
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="/#services" className="text-white/50 text-sm hover:text-white/80 transition-colors">
                  事業内容
                </a>
              </li>
              <li>
                <a href="/#about" className="text-white/50 text-sm hover:text-white/80 transition-colors">
                  会社概要
                </a>
              </li>
              <li>
                <a href="/#pricing" className="text-white/50 text-sm hover:text-white/80 transition-colors">
                  料金案内
                </a>
              </li>
              <li>
                <a href="/#contact" className="text-white/50 text-sm hover:text-white/80 transition-colors">
                  お問い合わせ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-medium tracking-[0.1em] text-white/60 mb-5">
              LEGAL
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="/privacy-policy" className="text-white/50 text-sm hover:text-white/80 transition-colors">
                  プライバシーポリシー
                </a>
              </li>
            </ul>
          </div>

          <div className="sm:col-span-2 lg:col-span-1">
            <h4 className="font-heading text-sm font-medium tracking-[0.1em] text-white/60 mb-5">
              CONTACT
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:050-8896-3509" className="text-white/50 text-sm hover:text-white/80 transition-colors flex items-center gap-2">
                  <i className="ri-phone-line text-white/30"></i>
                  050-8896-3509
                </a>
              </li>
              <li>
                <a href="mailto:admin@rse-tko.com" className="text-white/50 text-sm hover:text-white/80 transition-colors flex items-center gap-2">
                  <i className="ri-mail-line text-white/30"></i>
                  admin@rse-tko.com
                </a>
              </li>
              <li className="text-white/50 text-sm flex items-start gap-2">
                <i className="ri-map-pin-line text-white/30 mt-0.5"></i>
                <span>東京都新宿区下落合一丁目15番20-801号</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-white/30 text-xs">
            &copy; {currentYear} 合同会社RSE. All rights reserved.
          </p>
          <p className="text-white/25 text-xs">
            Powered by technology, driven by light.
          </p>
        </div>
      </div>
    </footer>
  );
}
